import React, { useState, useEffect } from 'react';
import { LoadingButton } from '@lf/ui-primitives';
import { getPendingChildLinks, approveChildLink, rejectChildLink } from '../../api/lfApiChildLink';

function PendingChildLinks({ onLinkResolved }) {
    const [requests, setRequests] = useState([]);

    async function fetchRequests() {
        const response = await getPendingChildLinks();
        if (response && response.data) {
            setRequests(response.data.pending_requests || []);
        }
    }

    useEffect(() => {
        fetchRequests();
    }, []);

    async function handleApprove(token) {
        const response = await approveChildLink(token);
        if (response && response.data && response.data.success) {
            await fetchRequests();
            if (onLinkResolved) onLinkResolved();
        }
    }

    async function handleReject(token) {
        const response = await rejectChildLink(token);
        if (response && response.data && response.data.success) {
            await fetchRequests();
        }
    }

    if (requests.length === 0) return null;

    return (
        <div className="border border-blue-400 border-2 bg-blue-50 p-4 mb-8 rounded-lg">
            <h3 className="font-semibold mb-3">Pending Link Requests</h3>
            {requests.map((req) => (
                <div key={req.token} className="flex items-center justify-between py-2 border-b border-blue-200 last:border-b-0">
                    <div className="text-sm">
                        <strong>{req.child_first_name}</strong> ({req.child_username}, Grade {req.child_grade_level}) wants to link their account to yours.
                    </div>
                    <div className="flex gap-2 ml-4">
                        <LoadingButton
                            text="Approve"
                            onClick={() => handleApprove(req.token)}
                        />
                        <button
                            className="bg-gray-300 text-gray-700 py-1 px-3 rounded text-sm"
                            onClick={() => handleReject(req.token)}>
                            Reject
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default PendingChildLinks;
